import axios from 'axios';

const API_URL = '/api/v1/portal-settings';

const getPortalSettings = async () => {
	return await axios.get(`${API_URL}`);
};

const updatePortalSettings = async (data) => {
	return await axios.put(`${API_URL}`, data);
};

export {
	getPortalSettings,
	updatePortalSettings,
};
